import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../assets/images/auth/auth-header.png'
import _imports_1 from '../../assets/images/auth/Btn_SignIn-1.png'
import _imports_2 from '../../assets/images/auth/Btn_SignIn-2.png'


const _hoisted_1 = { class: "mainAuthDv" }
const _hoisted_2 = { class: "auth" }
const _hoisted_3 = { class: "auth_wrapper" }
const _hoisted_4 = { class: "auth-td" }
const _hoisted_5 = { class: "auth--logo" }
const _hoisted_6 = { style: {"line-height":"27px"} }
const _hoisted_7 = { class: "auth--form auth-form-UI" }
const _hoisted_8 = {
  key: 0,
  class: "auth--form-head"
}
const _hoisted_9 = { class: "trademark" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-group-field" }
const _hoisted_12 = {
  key: 0,
  class: "form-group-error"
}
const _hoisted_13 = {
  key: 1,
  class: "form-group-error"
}
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "form-group-field" }
const _hoisted_16 = {
  key: 0,
  class: "form-group-error"
}
const _hoisted_17 = {
  key: 1,
  class: "form-group-error"
}
const _hoisted_18 = {
  key: 0,
  class: "btn btn--primary"
}
const _hoisted_19 = { class: "or-separator" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "icons__wrapper" }
const _hoisted_23 = ["src"]
const _hoisted_24 = {
  key: 1,
  class: "auth--form-foot footerformDv"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoComponent = _resolveComponent("LogoComponent")!
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[17] || (_cache[17] = _createElementVNode("figure", { class: "auth--banner" }, [
            _createElementVNode("img", {
              crossorigin: "anonymous",
              src: _imports_0
            })
          ], -1)),
          _createElementVNode("figure", _hoisted_5, [
            _createVNode(_component_LogoComponent, { noRtlTransform: "" }),
            _createElementVNode("figcaption", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.$t('auth.common.bannerText1')) + " ", 1),
              _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('auth.common.bannerText2')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (!_ctx.isPublicSignInMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("h6", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('auth.signin.heading')) + " ", 1),
                  _createElementVNode("span", _hoisted_9, [
                    _createVNode(_component_IconComponent, {
                      icon: "logo-txt.svg",
                      noRtlTransform: ""
                    })
                  ])
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('auth.signin.subHeading')), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "auth--form-body",
            onKeydown: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleKeydown && _ctx.handleKeydown(...args)))
          }, [
            _createVNode(_component_el_scrollbar, null, {
              default: _withCtx(() => [
                (!_ctx.isPublicSignInMode)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _cache[18] || (_cache[18] = _createElementVNode("label", { for: "userEmail" }, "Email address ", -1)),
                          _createVNode(_component_IconComponent, {
                            class: "iconInfoDv",
                            icon: "icon-email.svg"
                          }),
                          _createVNode(_component_el_input, {
                            maxlength: "256",
                            modelValue: _ctx.loginDTO.email,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginDTO.email) = $event)),
                            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputText(_ctx.loginDTO.email))),
                            type: "email",
                            "data-testing-Id": "email_login",
                            onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.debouncedInputText($event))),
                            placeholder: "Email or Username"
                          }, null, 8, ["modelValue"])
                        ]),
                        (_ctx.loginDTOError.email.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.loginDTOError.email), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.userNameError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[19] || (_cache[19] = [
                              _createElementVNode("p", null, "User Name must be at least 5 characters", -1)
                            ])))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _cache[20] || (_cache[20] = _createElementVNode("label", { for: "userPassword" }, "Password", -1)),
                          _createVNode(_component_IconComponent, {
                            class: "iconInfoDv",
                            icon: "icon-password.svg"
                          }),
                          _createVNode(_component_el_input, {
                            maxlength: "100",
                            modelValue: _ctx.loginDTO.password,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loginDTO.password) = $event)),
                            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.inputPassword(_ctx.loginDTO.password))),
                            onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.debouncedPasswordText($event))),
                            placeholder: "Password",
                            "data-testing-Id": "password_login",
                            type: "password",
                            "show-password": ""
                          }, null, 8, ["modelValue"])
                        ]),
                        (_ctx.loginDTOError.password.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.loginDTOError.password), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.userPasswordError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[21] || (_cache[21] = [
                              _createElementVNode("p", null, "Password must be at least 8 characters long.", -1)
                            ])))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_el_row, { class: "checkboxDv checkboxUi" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_checkbox, {
                                "data-testing-Id": "accountRemember_btn_login",
                                modelValue: _ctx.rememberMe,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.rememberMe) = $event)),
                                label: "Remember Me"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, {
                            span: 12,
                            class: "link_row"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                "data-testing-Id": "forgotPassword_btn_login",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToForgetPassword()))
                              }, _toDisplayString(_ctx.$t('auth.signin.forgot')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(
                  _ctx.isPublicSignInMode
                    ? 'publicSignInBtnRow'
                    : 'form-group non_border btn_row'
                )
                }, [
                  (!_ctx.isPublicSignInMode)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.isLoading)
                          ? (_openBlock(), _createElementBlock("button", _hoisted_18, _cache[22] || (_cache[22] = [
                              _createElementVNode("div", { class: "loader" }, null, -1)
                            ])))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "btn btn--primary",
                              "data-testing-Id": "login_btn",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onFormSubmit()))
                            }, " Sign In "))
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.isPublicSignInMode)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn--primary",
                        "data-testing-Id": "login_btn",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handlePublicSignIn()))
                      }, " Sign In "))
                    : _createCommentVNode("", true)
                ], 2),
                (_ctx.isPublicSignIn)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.goToSignUp())),
                      class: "newUserLink"
                    }, [
                      _cache[23] || (_cache[23] = _createTextVNode(" New To", -1)),
                      _createVNode(_component_LogoComponent, { className: "new-header-log" }),
                      _cache[24] || (_cache[24] = _createTextVNode("? ", -1)),
                      _cache[25] || (_cache[25] = _createElementVNode("span", { class: "joinLink" }, "Join Now", -1))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_19, [
                  (_ctx.isPublicSignIn)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Or Continue With"))
                    : (_openBlock(), _createElementBlock("div", _hoisted_21, "OR"))
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("a", {
                    "data-testing-Id": "facebook_btn_login",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.facebookLogin()))
                  }, _cache[26] || (_cache[26] = [
                    _createElementVNode("img", {
                      crossorigin: "anonymous",
                      src: _imports_1
                    }, null, -1)
                  ])),
                  _createElementVNode("a", {
                    "data-testing-Id": "x_btn_login",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.twitterLogin()))
                  }, [
                    _createElementVNode("img", {
                      crossorigin: "anonymous",
                      class: "socialPlatformIcons",
                      src: _ctx.getImageUrl('twitter' + '.png', 'social')
                    }, null, 8, _hoisted_23)
                  ]),
                  _createElementVNode("a", {
                    "data-testing-Id": "google_btn_login",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.googleLogin()))
                  }, _cache[27] || (_cache[27] = [
                    _createElementVNode("img", {
                      crossorigin: "anonymous",
                      src: _imports_2
                    }, null, -1)
                  ]))
                ])
              ]),
              _: 1
            })
          ], 32),
          (!_ctx.isPublicSignIn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('auth.signin.noAccount')), 1),
                _createElementVNode("p", {
                  "data-testing-Id": "signUp_btn_login",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.goToSignUp())),
                  class: "c-pointer iconPositonDv signUpBtnLogin"
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('auth.signin.signUpHere')) + " ", 1),
                  _createVNode(_component_IconComponent, {
                    class: "iconDv newIconInfoDv",
                    icon: "icon-forwarded-auth.svg"
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}